import Mapboxgl from "mapbox-gl";

Mapboxgl.accessToken =
  "pk.eyJ1IjoiamF2aWVyLW5lZXJpbmciLCJhIjoiY2x1Nzd3OTRqMDNiNjJpbXpybmVuazNnbiJ9.iQO1hmlJeE8eLf04vxjWEw";

if (!navigator.geolocation) {
  alert("Tu navegador no soporta geolocalización");
  throw new Error("Tu navegador no soporta geolocalización");
}
